import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const RULES = [
  {
    num: "01 / THE FOUNDATION RULE",
    title: "Grow deep before you grow big.",
    body: "Before asking for a bigger platform, more money or more responsibility, build the skills and discipline to handle it. A strong result needs a strong foundation.",
  },
  {
    num: "02 / THE TEAM & SYSTEM RULE",
    title: "Stop doing everything alone.",
    body: "Even a good idea can fail when one person is carrying the whole thing. Share responsibilities, build clear processes and make sure the work can move without you chasing everybody.",
  },
  {
    num: "03 / THE PIVOT RULE",
    title: "Adapt or get left behind.",
    body: "Plans will meet real-life challenges. Costs will change, people will disappoint you and the market will move. Strong leaders face the facts, adjust and keep moving.",
  },
];

export default function Playbook() {
  return (
    <section className="cream" id="playbook">
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">The playbook</div>
          <h2 className="title">Three rules for getting things done.</h2>
          <ThemeTag />
          <p className="intro">
            Good intentions matter. But growth needs more than intention. These are
            three principles we will put to work during the lab.
          </p>
        </Reveal>
        <div className="cards">
          {RULES.map((rule, i) => (
            <Reveal key={rule.num} delay={i * 0.12} className="card" data-testid="playbook-rule-card">
              <div className="num">{rule.num}</div>
              <h3>{rule.title}</h3>
              <p>{rule.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
